// Keep business failures on the same error path as rejected HTTP requests.
export const assertAPIResponse = (response) => {
  if (
    !response?.data ||
    response.data.success === false ||
    (typeof response.status === "number" &&
      (response.status < 200 || response.status >= 300))
  ) {
    const error = new Error(response?.data?.messageCode || "API request failed");
    error.response = response;
    throw error;
  }
  return response;
};
